// extracted by mini-css-extract-plugin
module.exports = {"root":"root--2hQif","sidebar":"sidebar--yObmc","content":"content--qm09I"};